module.exports = __webpack_public_path__ + "static/media/OpenSansHebrew-Regular.11544c36.ttf";